import { createTypedMagentoGraphqlClient } from "@/api/magento/graphql";

export async function fetchDiscontinuedProductName(sku: string, locale: string): Promise<string | null> {
  try {
    const magentoClient = createTypedMagentoGraphqlClient({ locale });
    const productResponse = await magentoClient.getProducts({
      sku: [sku],
    });
    const product = productResponse?.products?.items?.[0];
    return product?.name ?? null;
  } catch (error) {
    console.error("Failed to fetch discontinued product:", error);
    return null;
  }
}
